const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/insights/$insightId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { MOCK_INSIGHTS } from '@/components/loop-insights/hooks/mockInsights';
import { insightExists } from '@/components/loop-insights/utils/insightExists';
const paramsSchema = z.object({
  insightId: z.coerce.number().int().positive()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/insights/$insightId')({
  params: paramsSchema,
  loader: ({
    params
  }) => {
    if (!insightExists(params.insightId, MOCK_INSIGHTS)) {
      throw redirect({
        to: '/org/$org/loop/$loopId/insights',
        params: {
          org: params.org,
          loopId: params.loopId
        }
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});